import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SnapshotService} from './snapshot.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import * as SnapshotActions from './snapshot.actions';
import {of} from 'rxjs';

@Injectable()
export class SnapshotEffects {

  private readonly snapshotService: SnapshotService = inject(SnapshotService);
  private readonly actions$: Actions = inject(Actions);

  loadSnapshot$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SnapshotActions.loadSnapshot),
      mergeMap(action =>
        this.snapshotService.generateStudySnapshot(action.projectId, action.paperId).pipe(
          map(snapshot => SnapshotActions.loadSnapshotSuccess({snapshot})),
          catchError(error => of(SnapshotActions.loadSnapshotFailure({error})))
        )
      )
    )
  );

}
